import styled from "styled-components";

export const Modal = styled.div`
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ModalBg = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`;
export const ModalContent = styled.div`
  position: relative;
  z-index: 10;
  width: 847px;
  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  padding: 48px 27px;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      max-height: 100%;
      overflow-y: auto;
      border-radius: 20px;
    }
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  margin-bottom: 25px;
  color: #000000;

  @media screen and (max-width: 1024px) {
    & {
      margin-bottom: 0px;
      font-weight: 600;
      line-height: 29px;
      letter-spacing: -0.72px;
      color: #000000;
    }
  }
`;

export const BTCValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  margin-right: 12px;
  color: #F12E11;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;
export const LocalValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #F12E11;
`;

export const Body = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 55px;
  margin-bottom: 48px;
  border-bottom: 0.5px solid #cccccc;
  padding-top: 24px;
  padding-bottom: 40px;

  &.reject {
    padding-bottom: 0px;
    margin-bottom: 18px;
    border-bottom: none;
  }

  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const Row = styled.div`
  & {
  }
  @media screen and (max-width: 1024px) {
    & {
      margin: 0;
    }
  }
`;
export const Cell = styled.div`
  border-bottom: 0.5px solid #cccccc;
  height: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:last-child {
    border-bottom: none;
  }
  &.reject_reason {
    font-style: italic;
    background: #F5AA194D;
    padding: 10px 20px;
    border: none;
    & span {
      font-weight: 400;
      font-size: 14px;
    }
    @media screen and (max-width: 1024px) {
      height: 70px;
      margin: -12px 0px 12px 0px;
      & span {
        font-weight: 400;
        font-size: 13px;
      }
    }
  }
`;
export const CellTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  /* or 469% */

  color: #818181;
  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
    }
  }
`;
export const CellValue = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  & b {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    text-transform: capitalize;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 1024px) {
    & {
      max-width: 280px;
      font-size: 14px;
    }
    ,
    & b {
      font-size: 14px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const FormLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  color: #4d67c1;
  margin-top: 21px;
  cursor: pointer;
`;
